import React from 'react';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import PropTypes from 'prop-types';
import './Pencil.scss';

export const Pencil = ({ isOuterHovered, onClickCallback, tooltipContent, fill, hoverFill, disabled = false }) => {
  return (
    <div className='pencil-component'
      onClick={() => onClickCallback()}
    >
      <Svg
        className={ disabled ? 'pencil-icon-disabled' : 'pencil-icon' }
        data='/assets/edit.svg'
        fill={fill || colors.searchGrey}
        hoverable
        hoverFill={hoverFill || colors.iconHover}
        tooltipContent={tooltipContent}
      />
    </div>
  );
};

Pencil.propTypes = {
  isOuterHovered: PropTypes.bool,
  onClickCallback: PropTypes.func,
  tooltipContent: PropTypes.string,
  fill: PropTypes.string,
  hoverFill: PropTypes.string,
  disabled: PropTypes.bool,
};
